import NeoVarsityAcademyInput from './NeoAcademyModuleInput';
import ManageEmailField from './ManageEmailField';

const NeoVarsityUserActivitySync = () => {
  return (
    <div>
      <ManageEmailField />
      <NeoVarsityAcademyInput />
    </div>
  );
};

export default NeoVarsityUserActivitySync;
